import { Collection } from 'caldera-immutable-model';
import Task from './Task';

export default class TaskCollection extends Collection {
  static Model = Task;
}



// WEBPACK FOOTER //
// ./src/models/TaskCollection.js